import { BaseService } from "../services/baseService";
import type { ServiceResponse } from "../services/baseService";
import type { DocumentTemplate } from "../types/domain";
import { logger } from "../lib/logging/logger";

const base = new BaseService("document_templates");

export const templateRepository = {
  async findAllTemplates(): Promise<ServiceResponse<DocumentTemplate[]>> {
    logger.addBreadcrumb("template.findAll", { at: "repo" });
    const result = await base.findAll({
      columns: "id, name, description, document_type, template_content, variables, is_system_template, created_at, updated_at, user_id, usage_count, is_active",
      orderBy: { column: "created_at", ascending: false },
    });
    if (!result.success) {
      logger.error("Erro ao buscar templates", { error: result.error });
    }
    return result as ServiceResponse<DocumentTemplate[]>;
  },

  async createTemplate(
    templateData: {
      name: string;
      document_type: string;
      description: string;
    }
  ): Promise<ServiceResponse<DocumentTemplate>> {
    logger.addBreadcrumb("template.create", { name: templateData.name });
    
    const payload = {
      name: templateData.name,
      document_type: templateData.document_type,
      description: templateData.description,
      template_content: null,
      variables: {},
      is_system_template: false,
      is_active: true,
      usage_count: 0,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };

    const result = await base.create(payload as any);
    
    if (!result.success) {
      logger.error("Erro ao criar template", {
        name: templateData.name,
        error: result.error,
      });
    }
    
    return result as ServiceResponse<DocumentTemplate>;
  },

  async updateTemplate(
    templateId: string,
    templateData: {
      name?: string;
      document_type?: string;
      description?: string;
      template_content?: string;
      variables?: Record<string, any>;
      is_active?: boolean;
    }
  ): Promise<ServiceResponse<DocumentTemplate>> {
    logger.addBreadcrumb("template.update", { id: templateId });
    
    const result = await base.update(templateId, {
      ...templateData,
      updated_at: new Date().toISOString(),
    } as any);
    
    if (!result.success) {
      logger.error("Erro ao atualizar template", {
        id: templateId,
        error: result.error,
      });
    }
    
    return result as ServiceResponse<DocumentTemplate>;
  },
};